<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-credit-card-unavailable`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 24c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm8.905-18C45.062 6 46 6.895 46 8v15h-4v-3H6v18h16v4H4.095C2.938 42 2 41.105 2 40V8c0-1.105.938-2 2.095-2h39.81zM35 28a7 7 0 100 14 7 7 0 000-14zm4 5a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8zm3-23H6v6h36v-6z"/></svg>
</template>
<script>

export default {
  name: 'IconCreditCardUnavailable',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
